export const isFullStatic = false
export const staticPath = "C:/Users/tetz2/Documents/GitHub/Campsite.Profiles/.nuxt/static-json"
export const publicPath = "/"
export const globalContext = "__NUXT__"
export const globalNuxt = "$nuxt"